import { render, staticRenderFns } from "./ProjectRegistration.vue?vue&type=template&id=8ad3e412&scoped=true"
import script from "./ProjectRegistration.vue?vue&type=script&lang=js"
export * from "./ProjectRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad3e412",
  null
  
)

export default component.exports